/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Engagement_Milestone_TitleInputs */

const en_us2_engagement_milestone_title = /** @type {(inputs: Engagement_Milestone_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} workouts`)
};

const pt_br2_engagement_milestone_title = /** @type {(inputs: Engagement_Milestone_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} treinos`)
};

const es_419_engagement_milestone_title = /** @type {(inputs: Engagement_Milestone_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} entrenamientos`)
};

const pt_pt2_engagement_milestone_title = /** @type {(inputs: Engagement_Milestone_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} treinos`)
};

const fr_fr2_engagement_milestone_title = /** @type {(inputs: Engagement_Milestone_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} séances`)
};

const de_de2_engagement_milestone_title = /** @type {(inputs: Engagement_Milestone_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Trainings`)
};

const it_it2_engagement_milestone_title = /** @type {(inputs: Engagement_Milestone_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} allenamenti`)
};

/**
* | output |
* | --- |
* | "{count} workouts" |
*
* @param {Engagement_Milestone_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_milestone_title = /** @type {((inputs: Engagement_Milestone_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_Milestone_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_milestone_title(inputs)
	if (locale === "es-419") return es_419_engagement_milestone_title(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_milestone_title(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_milestone_title(inputs)
	if (locale === "de-DE") return de_de2_engagement_milestone_title(inputs)
	if (locale === "it-IT") return it_it2_engagement_milestone_title(inputs)
	return en_us2_engagement_milestone_title(inputs)
});
export { engagement_milestone_title as "engagement.milestone_title" }